import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ed6f27",
        secondary: "#f5f5f5",
        section0: "#ed6f27",
        section1: "#a7c7ad",
        section2: "#1c3a6d",
        section3: "#7fbed1"
      }
    }
  },
  icons: {
    iconfont: "mdiSvg"
  }
});
